export const featureFlags = {
    shouldSetupWebRTC: false
}